import { Typography, Box, Link } from "@mui/material";
import moment from "moment";

export default function Footer() {
  const tagDetails = process.env.REACT_APP_DEPLOYED_TAG;
  const safeTagDetails = tagDetails || "";
  const [tagName, buildDate, hash] = safeTagDetails.split("_");

  const tagVersion = tagName.split("-")[1];

  const formattedDate = buildDate
    ? moment(buildDate).format("MMMM D, YYYY")
    : "";

  const Last8 = hash?.slice(0, 8);

  return (
    <footer
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        zIndex: "1400",
      }}
    >
      <Box
        sx={{
          bgcolor: "#263238",
          height: "30px",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "rgba(255,255,255,0.7)",
          pl: "20px",
          pr: "20px",
          fontSize: "12px",
          letterSpacing: "0.12857144px",
          lineHeight: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="p"
            noWrap
            component="span"
            sx={{ ml: "2px", fontWeight: 400 }}
          >
            &copy; {new Date().getFullYear()} Datazoom. All Rights Reserved.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            px: 2,
            opacity: 0.3,
          }}
        >
          <Typography variant="p" noWrap component="span">
            Datazoom (Version {tagVersion})
          </Typography>
          <Typography variant="p" noWrap component="span">
            (Build {formattedDate})
          </Typography>
          <Typography variant="p" noWrap component="span">
            {Last8}
          </Typography>
        </Box>
        <Box
          sx={{
            textAlign: "right",
          }}
        >
          <Link
            style={{ marginRight: "13px", fontWeight: 400 }}
            underline="none"
            target="_blank"
            rel="noopener"
            href="https://www.datazoom.io/privacy-policy"
            color="inherit"
          >
            Privacy
          </Link>
          <Link
            style={{ fontWeight: 400, marginRight: "4px" }}
            underline="none"
            target="_blank"
            rel="noopener"
            href="https://www.datazoom.io/terms-and-conditions/"
            color="inherit"
          >
            Terms
          </Link>
        </Box>
      </Box>
    </footer>
  );
}
